import * as React from "react"
export const Svg_045 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M0 7.03h5.664v44.94H0V7.03Z" />
    <path
      fill="url(#b)"
      d="M58 7.03H25.736v44.94H58V7.03ZM36.77 45.056h-3.398V41.6h3.399v3.457Zm0-6.914h-3.398v-3.458h3.399v3.458Zm0-6.915h-3.398v-3.457h3.399v3.457Zm6.797 13.829H40.17V41.6h3.399v3.457Zm0-6.914H40.17v-3.458h3.399v3.458Zm0-6.915H40.17v-3.457h3.399v3.457Zm6.797 13.829h-3.398V41.6h3.398v3.457Zm0-6.914h-3.398v-3.458h3.398v3.458Zm0-6.915h-3.398v-3.457h3.398v3.457Zm3.105-6.914H30.268v-10.37h23.2v10.37Z"
    />
    <path fill="url(#c)" d="M9.063 3.572h13.275v51.856H9.062V3.572Z" />
    <path fill="url(#d)" d="M33.666 17.4H50.07v3.457H33.666V17.4Z" />
    <defs>
      <linearGradient
        id="a"
        x1={1.31}
        x2={10.658}
        y1={13.771}
        y2={15.677}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={33.197}
        x2={56.801}
        y1={13.771}
        y2={41.194}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={12.133}
        x2={31.611}
        y1={11.351}
        y2={19.421}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={37.46}
        x2={37.93}
        y1={17.919}
        y2={21.53}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)